<script lang="ts" setup>
import { onMounted, ref } from 'vue';
import Swiper from 'swiper/bundle';
import axiosApiClient from '@/axios';
import { useLocaleStore } from '../../stores/locale';
import { useI18n } from 'vue-i18n';

const isbusy = ref(false);
const ourProjects = ref<any[]>([]);
const localeStore = useLocaleStore();

const t = useI18n().t;
const fetchProjects = async () => {
  isbusy.value = true;
  const response = await axiosApiClient.get('/api/projects/public');
  ourProjects.value = response.data;
  isbusy.value = false;
};
fetchProjects();

onMounted(() => {
  new Swiper('.innovative-slider', {
    slidesPerView: 3,
    spaceBetween: 30,
    loop: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
    },
  });
  new Swiper('.mySwiper', {
    slidesPerView: 4,
    spaceBetween: 30,
    loop: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      640: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 40,
      },
    },
  });
  new Swiper('.mySwiper2', {
    slidesPerView: 4,
    spaceBetween: 30,
    loop: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      640: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 40,
      },
    },
  });
  new Swiper('.mySwiper3', {
    slidesPerView: 4,
    spaceBetween: 30,
    loop: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      640: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 40,
      },
    },
  });
});
</script>
<template>
  <loading-spinner :is-loading="isbusy" :position="'relative'" />
  <section class="section-innovative" :dir="localeStore.locale === 'ar' ? 'rtl' : 'ltr'">
    <div class="container">
      <div class="heading sec-title-animation animation-style2 flex mt-4 gap-7">
        <div>
          <img src="../../../assets/img/heading-img.png" alt="img" />
          <span class="title-animation">{{ t('Work Showcase') }}</span>
        </div>
        <div>
          <h4 class="title-animation">
            {{ t('Selection of Our Recent Projects') }}
          </h4>
        </div>
      </div>
      <div class="swiper innovative-slider">
        <div class="swiper-wrapper gap-1">
          <div class="swiper-slide innovative hover-img flex-grow" v-for="project in ourProjects" :key="project.id">
            <figure>
              <img :src="'data:image/png;base64,' + project.thumbnail" :alt="project.description"
                style="height: 50vh; object-fit: cover" />
            </figure>
            <div class="client-company">
              <h4>{{ project.description }}</h4>
              <h4><b>{{ project.name }}</b></h4>
              <ul>
                <li>
                  {{ t('Date') }}
                  <span>{{ project.end_date }}</span>
                </li>
                <li>
                  {{ t('Client') }}
                  <span>{{ project.owner }}</span>
                </li>
                <li>
                  {{ t('Duration') }}
                  <span>
                    {{ project.duration }}
                    <b>{{ t(project.duration_unit) }}</b>
                  </span>
                </li>
                <li v-if="project.units.length > 0">
                  {{ t('Units') }}
                  <span>{{ project.units.length }}</span>
                </li>
              </ul>
              <div class="project-cost flex flex-col" dir="ltr">
                <span>{{ t('Project Cost') }}</span>
                <h6>{{ project.cost.toLocaleString() }}</h6>
              </div>
              <div>
                <a :href="'/project/' + project.id" :id="'project-' + project.id">
                  <i :class="localeStore.locale == 'ar'
                    ? 'fa-solid fa-arrow-left'
                    : 'fa-solid fa-arrow-right'
                    "></i>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-pagination"></div>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
figure {
  width: 40vw;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}
</style>
